export const DATEV_MODALS = {
  create: 'create',
  delete: 'delete',
  change: 'change',
};

export const DEFAULT_DATEV_TO_DELETE = {
  _id: '',
  datevNumber: '',
  status: '',
  consultantNumberId: '',
};
